module.exports = __webpack_public_path__ + "img/black_leather_jacket-120x156.5b7bf8bc.jpg";